import AppButton from '@/components/Button/AppButton/AppButton';
import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import appContent from '@/services/content/appContent.typed';
import appRouterService from '@/services/route/appRouterService';

interface StatusActiveSkipButtonProps {
    className?: string;
}

const StatusActiveSkipButton = ({className}: StatusActiveSkipButtonProps) => {
    const content = appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};
    const {skipDeliveryButton} = content;
    const isDesktop = useIsDesktopLayout();

    if (!skipDeliveryButton) return null;

    return (
        <AppButton
            secondary
            light={isDesktop}
            className={className}
            aria-label={skipDeliveryButton.alt}
            onClick={appRouterService.forwardToAutoDeliverySkipPage}
        >
            {skipDeliveryButton.text}
        </AppButton>
    );
};

export default StatusActiveSkipButton;
